import styled from 'styled-components';
import { Block, BlockProps } from './Block';

export const BlockImg = styled(Block.withComponent('img'))<BlockProps>``;
